// Базовые значения сверены с Dum-Tragut (2009) и Sakayan (2007).
// Аллофонный кластер ղջ подтверждён примером աղջիկ: [ɑχt͡ʃʰik].
const ARMENIAN_LETTERS = /[\u0531-\u0556\u0561-\u0587]/u

const LETTER_TO_IPA: Record<string, string> = {
  ա: 'ɑ',
  բ: 'b',
  գ: 'ɡ',
  դ: 'd',
  ե: 'ɛ',
  զ: 'z',
  է: 'ɛ',
  ը: 'ə',
  թ: 'tʰ',
  ժ: 'ʒ',
  ի: 'i',
  լ: 'l',
  խ: 'χ',
  ծ: 't͡s',
  կ: 'k',
  հ: 'h',
  ձ: 'd͡z',
  ղ: 'ʁ',
  ճ: 't͡ʃ',
  մ: 'm',
  յ: 'j',
  ն: 'n',
  շ: 'ʃ',
  ո: 'ɔ',
  չ: 't͡ʃʰ',
  պ: 'p',
  ջ: 'd͡ʒ',
  ռ: 'r',
  ս: 's',
  վ: 'v',
  տ: 't',
  ր: 'ɾ',
  ց: 't͡sʰ',
  ւ: 'v',
  փ: 'pʰ',
  ք: 'kʰ',
  օ: 'ɔ',
  ֆ: 'f',
}

const VOICELESS_CONSONANTS = new Set(['պ', 'տ', 'կ', 'թ', 'փ', 'ք', 'ծ', 'ց', 'ճ', 'չ', 'ֆ', 'ս', 'շ', 'խ', 'հ'])

function isArmenianLetter(ch: string | undefined): boolean {
  return ch !== undefined && ARMENIAN_LETTERS.test(ch)
}

function isWordStart(text: string, index: number): boolean {
  return !isArmenianLetter(Array.from(text)[index - 1])
}

function nextArmenianLetter(text: string, index: number): string | undefined {
  const chars = Array.from(text)
  for (let i = index + 1; i < chars.length; i++) {
    if (isArmenianLetter(chars[i])) return chars[i]
    if (!/\s/u.test(chars[i])) return undefined
  }
  return undefined
}

function previousArmenianLetter(text: string, index: number): string | undefined {
  const chars = Array.from(text)
  for (let i = index - 1; i >= 0; i--) {
    if (isArmenianLetter(chars[i])) return chars[i]
    if (!/\s/u.test(chars[i])) return undefined
  }
  return undefined
}

function phonemeForLetter(text: string, index: number, letter: string): string {
  const next = nextArmenianLetter(text, index)
  const previous = previousArmenianLetter(text, index)

  if (letter === 'ո' && next === 'ւ') return 'u'
  if (letter === 'ե' && isWordStart(text, index)) return 'jɛ'
  if (letter === 'ո' && isWordStart(text, index)) return 'vɔ'
  if (letter === 'և') return isWordStart(text, index) ? 'jɛv' : 'ɛv'

  // In Eastern Armenian, ղ devoices before a voiceless consonant.
  if (letter === 'ղ' && next && (next === 'ջ' || VOICELESS_CONSONANTS.has(next))) return 'χ'

  // The sequence ղջ is pronounced as a voiceless uvular plus aspirated ч.
  if (letter === 'ջ' && previous === 'ղ') return 't͡ʃʰ'

  return LETTER_TO_IPA[letter] ?? letter
}

export function armenianToIpa(text: string): string {
  const startsUppercase = text.length > 0 && text[0] !== text[0].toLowerCase()
  const normalizedText = text.toLowerCase()
  const chars = Array.from(normalizedText)
  let result = ''
  for (let index = 0; index < chars.length; index++) {
    const letter = chars[index]
    if (letter === 'ո' && chars[index + 1] === 'ւ') {
      result += 'u'
      index++
      continue
    }
    if (letter === 'և') {
      result += phonemeForLetter(normalizedText, index, letter)
      continue
    }
    result += phonemeForLetter(normalizedText, index, letter)
  }
  return startsUppercase ? result.charAt(0).toUpperCase() + result.slice(1) : result
}
